<div>
    <div class="card p-2 m-2" *ngIf="!enableNewProfilePage && !enableUpdateProfilePage">
        <div class="Tabletitle">
            <span class="Tabletitle"> Redaction Profiles Table </span>
        </div>

        <div>
            <button class="m-1" mat-raised-button (click)="enableNewProfile('new')">Create New Profile</button>
            <mat-form-field class="element-filter" *ngIf="redactionProfilesTableArray">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilter($event)">
            </mat-form-field>
            <div class="m-1 mt-1" *ngIf=redactionProfilesTableArray style="float:right">
                (Total Count: {{redactionProfilesTableArray.length}})
            </div>
        </div>

        <table style="width: 100%;" mat-table [dataSource]="redactionProfilesDataSource" class="mat-elevation-z8 mt-2">

            <ng-container matColumnDef="profileId">
                <th mat-header-cell *matHeaderCellDef><b>PROFILE ID</b></th>
                <td mat-cell *matCellDef="let element; let i = index;">{{element['Profile ID']}}</td>
            </ng-container>


            <ng-container matColumnDef="profileName">
                <th mat-header-cell *matHeaderCellDef><b>PROFILE NAME</b></th>
                <td mat-cell *matCellDef="let element; let i = index;">{{element['Profile Name']}}</td>
            </ng-container>

            <ng-container matColumnDef="selectedFields">
                <th mat-header-cell *matHeaderCellDef><b>SELECTED FIELDS</b></th>
                <td mat-cell *matCellDef="let element; let i = index;">{{element['selectedFieldNames']}}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef><b>ACTIONS</b></th>
                <td mat-cell *matCellDef="let element; let i = index;">
                    <mat-icon (click)="enableNewProfile('update', element)">edit</mat-icon>
                    <mat-icon (click)="deleteProfile(element['Profile ID'])">delete</mat-icon>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <div class="card p-2 m-2" *ngIf="enableNewProfilePage || enableUpdateProfilePage">
        <form [formGroup]="profileForm">
            <div>
                <div class="Tabletitle">{{enableNewProfilePage ? 'Create New Redaction Profile':'Update Redaction
                    Profile'}}
                </div>

                <div>
                    <div class="row m-0 p-0">
                        <div class="mt-3">
                            <div class="row m-0 p-0">
                                <div class="input-group mb-3 input-group col-sm-12">
                                    <div class="input-group-prepend" style="display: block;">
                                        <span class="input-group-text">Redaction Profile Name</span>
                                    </div>
                                    <input type="text" class="form-control" formControlName="profileName"
                                        id="profileName" name="profileName">
                                    <!-- <label style="padding: 0px;" for="redactionCatId">A Category will be created for all redacted documents</label> -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="border p-2 mt-2">

                        <mat-expansion-panel #panel1 [expanded]="expansionPanelExpanded[0]">
                            <mat-expansion-panel-header>
                                <mat-panel-title style="align-items: center;">
                                    <div class="ml-2">Select PII Fields</div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="row mb-3">

                                <div class="input-group input-group col-12">
                                    <div class="input-group-prepend" style="display: block;">
                                        <span class="input-group-text">Select/Deselect All</span>
                                    </div>
                                    <!-- [disabled]="this.fetchedCatName && (this.fetchedCatName.indexOf('Redacted') > -1 || this.fetchedCatName.indexOf('Review') > -1)" -->
                                    <mat-slide-toggle (change)="selectDeselectAllPiiFields($event)" id="piiSelectToggle" class="pl-2 pr-2 ml-3  align-self-center" [checked]="selectAllPiiToggle">
                                    </mat-slide-toggle>
                                </div>

                            </div>

                            <div class="row m-0 mt-4 mb-4 basic-grid">
                                <button type="button" *ngFor="let piifield of piiList; let i = index" [class]="this.profileForm.controls.selectedPiiFields.value.includes(piifield) ? 'roundedCorners custom-btn-success buttonSelected':'roundedCorners custom-btn-success'" (click)="onSelectPiiFields(piifield)">{{piifield['Field Name']}}</button>
                            </div>

                            <div class="row m-0 mt-4 mb-4 basic-grid"
                                style="display: flex; justify-content: flex-end; padding-right: 20px;">
                                <div>
                                    <fieldset style="border: solid; padding: revert;">
                                        <div>
                                            <div style="display: flex; align-items: center;"><span
                                                    class="material-icons">circle</span> : Selected</div>
                                            <div style="display: flex; align-items: center;"><span
                                                    style="color: #E8E8E8;" class="material-icons">circle</span> :
                                                Unselected</div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </mat-expansion-panel>


                        <mat-expansion-panel #panel2 [expanded]="expansionPanelExpanded[1]">
                            <mat-expansion-panel-header>
                                <mat-panel-title style="align-items: center;">
                                    <!-- <input type="radio" [checked]="panel3.expanded"> -->
                                    <div class="ml-2">Select PHI Fields</div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="row mb-3">

                                <div class="input-group input-group col-12">
                                    <div class="input-group-prepend" style="display: block;">
                                        <span class="input-group-text">Select/Deselect All</span>
                                    </div>
                                    <!-- [disabled]="this.fetchedCatName && (this.fetchedCatName.indexOf('Redacted') > -1 || this.fetchedCatName.indexOf('Review') > -1)" -->
                                    <mat-slide-toggle (change)="selectDeselectAllPhiFields($event)" id="phiSelectToggle" class="pl-2 pr-2 ml-3  align-self-center" [checked]="selectAllPhiToggle"></mat-slide-toggle>
                                </div>

                            </div>

                            <div class="row m-0 mt-4 mb-4 basic-grid">
                                <button type="button" *ngFor="let phifield of phiList; let i = index"
                                [class]="this.profileForm.controls.selectedPhiFields.value.includes(phifield) ? 'roundedCorners custom-btn-success buttonSelected':'roundedCorners custom-btn-success'" (click)="onSelectPhiFields(phifield)">{{phifield['Field Name']}}</button>
                            </div>

                            <div class="row m-0 mt-4 mb-4 basic-grid"
                                style="display: flex; justify-content: flex-end; padding-right: 20px;">
                                <div>
                                    <fieldset style="border: solid; padding: revert;">
                                        <!-- <legend style="width: unset;">Legend</legend> -->
                                        <div>
                                            <div style="display: flex; align-items: center;"><span
                                                    class="material-icons">circle</span> : Selected</div>
                                            <div style="display: flex; align-items: center;"><span
                                                    style="color: #E8E8E8;" class="material-icons">circle</span> :
                                                Unselected</div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </mat-expansion-panel>


                        <mat-expansion-panel #panel3 [expanded]="expansionPanelExpanded[2]">
                            <mat-expansion-panel-header>
                                <mat-panel-title style="align-items: center;">
                                    <!-- <input type="radio" [checked]="panel2.expanded"> -->

                                    <div class="ml-2">Select Custom Redaction Fields</div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="row" style="height: auto; margin: 0;">
                                <button type="button" (click)="toggleAddCustomFieldPopup('open')"
                                    style="align-items: center; display: flex; width: auto; background-color: #6ec01b; color: white;"
                                    class="roundedCorners custom-btn-success pr-3"><span
                                        class="material-icons mr-3">add</span>Add New Field</button>

                            </div>

                            <div class="row m-0 mt-4 mb-4 basic-grid">
                                <button type="button" *ngFor="let customField of customList; let i = index"
                                    style="align-items: center; display: flex; justify-content: center;"
                                    [class]="this.profileForm.controls.selectedCustomFields.value.includes(customField) ? 'roundedCorners custom-btn-success pr-3 buttonSelected':'roundedCorners custom-btn-success pr-3'" (click)="onSelectCustomFields(customField)" ><span
                                        class="material-icons mr-3" (click)="toggleAddCustomFieldPopup('openForEdit', i); $event.stopPropagation();">edit</span>{{customField['value']}}</button>
                            </div>

                            <div *ngIf="customList.length > 0" class="row m-0 mt-4 mb-4 basic-grid"
                                style="display: flex; justify-content: flex-end; padding-right: 20px;">
                                <div>
                                    <fieldset style="border: solid; padding: revert;">
                                        <div>
                                            <div style="display: flex; align-items: center;"><span
                                                    class="material-icons">circle</span> : Selected</div>
                                            <div style="display: flex; align-items: center;"><span
                                                    style="color: #E8E8E8;" class="material-icons">circle</span> :
                                                Unselected</div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </div>
                </div>
            </div>
            <button mat-raised-button class="backButton m-1" (click)="back()">Back</button>
            <button mat-raised-button class="actionButton m-1" [disabled]="!profileForm.valid" (click)="save()">{{button}}</button>
            <!-- <button mat-raised-button class="actionButton m-1" [disabled]="!profileForm.valid" *ngIf="button === 'Update'" (click)="update()">{{button}}</button> -->
        </form>
    </div>

    <ng-template #addCustomFieldPopup>
        <div class="card mt-3">
            <div class="card-body" style="text-align: center;">
                <div class="container" style="height: auto;">
                    <h5>Enter the name of the field (key) that you would like to redact</h5>
                    <div class="input-group-sm mb-3 input-group col-12">
                        <div class="input-group-prepend">
                            <span class="input-group-text form-label-105 w-100">Custom Field Name</span>
                        </div>
                        <input type="text" [(ngModel)]="customFieldName" class="form-control" id="customFieldName" name="customFieldName">
                    </div>
                    <label>Note: The created field should exactly match the key in the form. If it does not match then the value for that key won't be redacted</label>
                    <div class="row mt-3 mb-3" style="height: auto;">
                        <div class="col-12">
                            <button mat-close mat-flat-button style="float: right;" *ngIf="saveUpdateCustomFieldButton === 'save'" class="ml-2 backButtonColor"
                                (click)="toggleAddCustomFieldPopup('close')">Back</button>
                                <button mat-close mat-flat-button style="float: right;" *ngIf="saveUpdateCustomFieldButton === 'update'" class="ml-2 backButtonColor"
                                (click)="toggleAddCustomFieldPopup('delete')">Delete</button>
                            <button mat-close mat-flat-button style="float: right;" *ngIf="saveUpdateCustomFieldButton === 'save'" (click)="toggleAddCustomFieldPopup('save')"
                            class="actionButtonColor">{{saveUpdateCustomFieldButton}}</button>
                            <button mat-close mat-flat-button style="float: right;" *ngIf="saveUpdateCustomFieldButton === 'update'" (click)="toggleAddCustomFieldPopup('update')"
                            class="actionButtonColor">{{saveUpdateCustomFieldButton}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #deletecustomFieldPopup>
        <div class="card mt-3">
            <div class="card-body" style="text-align: center;">
                <div class="container" style="height: auto;">
                    <h5>Are you sure you want to delete the selected field?</h5>
                    <div class="row mt-3 mb-3" style="height: auto;">
                        <div class="col-12">
                            <button mat-close mat-flat-button style="float: right;" class="ml-2 backButtonColor"
                                (click)="deleteCustomFieldActions('close')">No</button>
                            <button mat-close mat-flat-button style="float: right;" (click)="deleteCustomFieldActions('delete')"
                            class="actionButtonColor">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #deleteProfilePopup>
        <div class="card mt-3">
            <div class="card-body" style="text-align: center;">
                <div class="container" style="height: auto;">
                    <h5>Are you sure you want to delete the selected Profile?</h5>
                    <div class="row mt-3 mb-3" style="height: auto;">
                        <div class="col-12">
                            <button mat-close mat-flat-button style="float: right;" class="ml-2 backButtonColor"
                                (click)="confirmDeleteProfile('close')">No</button>
                            <button mat-close mat-flat-button style="float: right;" (click)="confirmDeleteProfile('delete')"
                            class="actionButtonColor">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>